export default "__VITE_ASSET__5862043f__"